<template>
  <div class="dialogCustom">
    <div style="border-radius: 8px; display: flex" v-for="formTemplate in basicInfoData.sections">
      <el-dialog
        v-model="dialogVisible"
        title="Tips"
        width="500"
        :before-close="handleClose"
        align-center
        :close-on-click-modal="false"
      >
      <template #header="{ close, titleId, titleClass }">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: sticky;
              "
              class="fixed-header"
            >
              <h4 :id="titleId" :class="titleClass" class="my-header">
                {{ formTemplate.title }}
              </h4>
              <img
                @click="handleLeadCaptureClose()"
                src="../../assets/close.svg"
                style="height: 20px; width: 20px; cursor: pointer"
              />
            </div>
          </template>
          <div>
            <div
              style="
                display: flex;
                flex-direction: column;
                gap: 10px;
                padding: 16px 20px;
              "
            >
              <span class="dialog_title">{{ formTemplate.description }}.</span>
              <div v-for="fields in getFilteredFields(formTemplate.fields)">
                <div
                  class="productTypes"
                  v-if="fields.question_type === 'multiple_choice'"
                >
                  <p class="dialog_title">
                    {{ fields.label }}
                    <span
                      class="requiredClass"
                      v-if="fields.is_required === true"
                      >*</span
                    >
                  </p>
                  <div class="categoryInput">
                    <el-radio-group
                       v-if="fields.label !== 'Type of Product'"
                       v-model="fields.additional_info.default_option"
                      @change="() => { 
                        updateCalculatorData(
                          fields.additional_info.default_option,
                          fields.label,
                          fields.question_type,
                          fields
                        );
                      }"
                    >
                      <el-radio
                        :label="option.option_text"
                        class="categoryOptions"
                        v-for="option in fields.options"
                        :key="option.option_text"
                      >
                        {{ option.option_text }}
                      </el-radio>
                    </el-radio-group>
                    <el-radio-group
                       v-else
                       :model-value="getRadioValue(fields.additional_info.default_option)"
                       disabled
                    >
                      <el-radio
                        :label="option.option_text"
                        class="categoryOptions"
                        disabled
                        v-for="option in fields.options"
                        :key="option.option_text"
                      >
                        {{ option.option_text }}
                      </el-radio>
                      </el-radio-group>
                        <div class="input_containers" v-for="option in fields.options" :key="option.option_text">
                          <div  v-if="option.sub_options && fields.additional_info.default_option =='Company/Society/Institution'"  v-for="subOption in option.sub_options" :key="subOption.label">
                            <p class="dialog_title">
                              {{ subOption.label }}<span
                                class="requiredClass"
                                v-if="(subOption.is_required = true)"
                                >*</span
                              >
                            </p>
                            <el-input
                              :placeholder="getPlaceHolder(subOption.label)"
                              :class="getInputStyles(subOption.label)"
                              v-model="subOption.additional_info.default_option"  
                              style="color: black; font-size: 16px"
                              @input="updateCalculatorData(subOption.additional_info.default_option,
                             subOption.label,
                             subOption.question_type,
                            subOption)"
                            >
                            </el-input>
                          </div>
                        </div>

                    <div
                      v-if="fields.additional_info.default_option === 'Yes'"
                      v-for="data in fields.options"
                      class="productTypes"
                    >
                      <div v-for="options in data.sub_options">
                        <p class="dialog_title">{{ options.label }}</p>
                        <el-select
                          v-model="options.additional_info.default_option"
                          placeholder="Select the Timeline"
                          style="margin-top: 5px; width: 100%"
                          @change="updateAnswerApi(fields)"
                        >
                          <el-option
                            v-for="item in options.options"
                            :label="item.option_text"
                            :value="item.option_text"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="fields.question_type === 'dropdown'"
                  class="dropdownContainer"
                >
                  <p class="dialog_title">{{ fields.label }}</p>

                  <el-select
                    v-model="fields.additional_info.default_option"
                    placeholder="Select the Timeline"
                    style="margin-top: 10px; width: 100%"
                    @change="
                      updateCalculatorData(
                        fields.additional_info.default_option,
                        fields.label,
                        fields.question_type,
                        fields
                      )
                    "
                  >
                    <el-option
                      v-for="item in fields.options"
                      :label="item.option_text"
                      :value="item.option_text"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-if="fields.question_type === 'file_upload'">
                  <p class="dialog_title">
                    {{ fields.label }}
                  </p>
                  <div
                    v-if="!uploadedFile.file_name"
                    class="file_upload_card"
                    @click="openUploadDialog"
                  >
                    <img src="../../assets/upload.svg" alt="" />
                    <p>Upload File</p>
                    <input
                      id="fileInput"
                      type="file"
                      ref="fileInput"
                      :multiple="false"
                      @change="fileUpload($event, fields)"
                      class="file_input"
                      accept=".jpg,.jpeg,.png,.pdf"
                    />
                  </div>

                  <div v-if="imageUrl">
                    <img :src="imageUrl" alt="" />
                  </div>

                  <div class="img_container" v-if="uploadedFile.file_name">
                    <img src="../../assets/img.svg" alt="" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="uploadedFile.file_info"
                      placement="top-start"
                    >
                      <p
                        style="
                          width: 90%;
                          overflow: hidden;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          cursor: pointer;
                          text-align: center;
                        "
                      >
                        {{ uploadedFile.file_info }}
                      </p>
                    </el-tooltip>
                    <img
                      src="../../assets/deleteIcon.svg"
                      alt=""
                      @click="deleteUploadedFiles"
                      style="cursor: pointer"
                    />
                  </div>
                </div>

                <div
                  v-if="
                    fields.label === 'Recommended Solar Capacity' &&
                    fields.photos_videos_required !== true
                  "
                  class="input_containers"
                >
                  <p class="dialog_title">
                    {{ fields.label }}
                  </p>

                  <div
                    style="display: flex; align-items: center"
                    class="input_capacity"
                  >
                    <input
                      :value="getProductTypeFromFields() === 'on_grid' ? calculatorData.customer_recommended_system_size : calculatorData.dc_size"
                      disabled
                      placeholder="Please input your System size."
                      class="capacity_input"
                    />
                    <p style="margin-left: auto; color: #ccc">kW</p>
                  </div>
                </div>

                <div
                  v-if="
                    (fields.question_type === 'short_answer' ||
                      fields.question_type === 'number') &&
                    fields.photos_videos_required !== true &&
                    fields.label !== 'Pincode' &&
                    fields.label !== 'Recommended Solar Capacity'
                  "
                  class="input_containers"
                >
                  <p class="dialog_title">
                    {{ fields.label }}
                    <span
                      class="requiredClass"
                      v-if="(fields.is_required = true)"
                      >*</span
                    >
                  </p>
                  <el-input
                    :placeholder="getPlaceHolder(fields.label)"
                    v-model="fields.additional_info.default_option"
                    :type="fields.label === 'Mobile No.' ? 'number' : 'text'"
                    :maxlength="fields.label === 'Mobile No.' ? 10 : 100"
                    @focus="handleFocus(fields.label)"
                    @blur.prevent="
                      handleValidation(
                        fields.additional_info.default_option,
                        fields.label
                      )
                    "
                    :class="getInputStyles(fields.label)"
                    @input="
                      updateCalculatorData(
                        fields.additional_info.default_option,
                        fields.label,
                        fields.question_type,
                        fields
                      )
                    "
                    @keydown="preventSpecialCharacters(fields.label, $event)"
                    style="color: black; font-size: 16px"
                  >
                  </el-input>

                  <!-- <div v-if="fields.label === 'Name'">hello</div> -->
                  <div
                    v-if="fields.label === 'Email' && email_error === true"
                    class="error_field"
                  >
                    Input valid email ID
                  </div>
                  <div
                    v-if="
                      fields.label === 'Mobile No.' && mob_no_error === true
                    "
                    class="error_field"
                  >
                    Input valid mobile number.
                  </div>
                  <div
                    v-if="fields.label === 'Name' && name_error === true"
                    class="error_field"
                  >
                    Input valid name
                  </div>
                </div>

                <div
                  v-if="
                    fields.label === 'Pincode' &&
                    fields.photos_videos_required !== true
                  "
                  class="input_containers"
                >
                  <p class="dialog_title">
                    {{ fields.label }}
                  </p>

                  <div
                    style="display: flex; align-items: center"
                    class="input_capacity"
                  >
                    <input
                      :value="calculatorData.pin_code"
                      disabled
                      placeholder="Please input your System size."
                      class="capacity_input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="check_box" style="display: flex; align-items: center" v-if="!calculatorData.isTata || (calculatorData.isTata && isGenerate)">
              <el-checkbox
                v-model="readAgreement"
                :class="['custom-checkbox', calculatorData.isTata ? 'customCheckboxColor' : 'defaultCheckboxColor']"
              ></el-checkbox>
              <span style="margin-left: 10px;
              font-size: 13px;
              color: #222">
                I have read and agree to
                <span>
                  <span
                    style="
                      font-weight: bold;
                      text-decoration: underline;
                      cursor: pointer;
                      margin-left: 2px;
                      color: #222;
                    "
                    @click.stop="getTerms"
                    >Terms & Conditions</span
                  >. Sign me up for updates.</span
                >
              </span>
            </div>
            <div
              class="Verification"
              style="position: sticky; bottom: 0; padding: 10px"
            >
              <button
                :class="[buttonStyles(), !calculatorData.isTata ? 'diffOrgButton' : '']"
                :disabled="buttonDisabled()"
                @click="verifyDetails"
                style="text-transform: none"
              >
                {{calculatorData.isTata ? isGenerate ? 'Verify Your Number' : 'View Savings' : 'Verify Your Number'}}
              </button>
            </div>
          </div>
      </el-dialog>
    </div>
    <div class="loading_popup">
      <el-dialog
        v-model="loading"
        width="30%"
        :top="'45vh'"
        :close-on-click-modal="false"
        align-center
      >
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 24px;
            padding-bottom: 40px;
          "
        >
          <img
            class="loading_gif"
            style="width: 70px; height: 70px"
            src="../../assets/giphy.gif"
          />
          <p>Sending OTP To Your Mobile Number</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue'
import { v4 } from "uuid";
import API from '../../../../services/api'
import debounce from "debounce";
import { computed } from 'vue'
import { ElMessageBox } from 'element-plus'
import { solarCalculatorStore } from '../../../store/solarCalculator'
import { uploadFileToBlob } from "@/utils.js";
import axios from 'axios';

const loading = ref(false);

const props = defineProps({
dialogVisible: Boolean,
basicInfoData: Object,
isGenerate: Boolean,
});

const uploadedFile = ref({});
const name_error = ref(false);
const email_error = ref(false);
const mob_no_error = ref(false);
const imageUrl = ref("");
const fileInput = ref(null);
const optArray = ref([]);
const readAgreement = ref(false);
const timer = ref(0);

const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;


const emit = defineEmits(['update:dialogVisible', 'verificationDialog', 'generateResults'])

const getFilteredFields = (fields) => {
  if (props.isGenerate && calculatorData.isTata) {
    const allowedLabels = ['Account Type', 'Name', 'Email', 'Mobile No.'];
    return fields.filter(field => allowedLabels.includes(field.label));
  } else if(!props.isGenerate && calculatorData.isTata) {
    const allowedLabels = ["Type of Product", "Is your building under construction?", "Upload Monthly Electricity Bill", "Recommended Solar Capacity", "Pincode"];
    return fields.filter(field => allowedLabels.includes(field.label));
  } else {
    return fields;
  }
};

const getRadioValue = (value) => {
  return value === 'on_grid' ? 'On-Grid' : 'Off-Grid';
};

const updateRadioValue = (newValue, target, property) => {
  target[property] = newValue === 'On-Grid' ? 'on_grid' : newValue;
};

const getProductTypeFromFields = () => {
  // Find the "Type of Product" field from basicInfoData sections
  if (props.basicInfoData?.sections) {
    for (const section of props.basicInfoData.sections) {
      for (const field of section.fields) {
        if (field.label === 'Type of Product') {
          return field.additional_info.default_option;
        }
      }
    }
  }
  return calculatorData.product_type;
};

const getTerms = () => {
  if(calculatorData.isTata){
    window.open("https://www.tatapowersolar.com/terms-of-use/");
  } else {
    window.open("https://arka360.com/in/terms");
  }
};

const deleteUploadedFiles = () => {
  const file_upload = {
    answer: {
      additional_info: {},
      corners: {
        address: "",
        center: {},
        coordinates: [],
        map_image: [],
        zoom: "",
      },
      deleted_files: [uploadedFile.value.file_name],
      files: [],
      options: [],
      sub_options: {
        question_type: "",
        value: "",
      },
      text: "",
    },
    question: uploadedFile.value.id,
    question_type: "file_upload",
    site_survey: calculatorData.site_survey_token,
  };

  const callApi = debounce(async () => {
    await API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(file_upload);
  });
  callApi();
  uploadedFile.value = {};
};

const getPlaceHolder = (label) => {
  return `Enter ${label}`;
};

const getInputStyles = (fields) => {
  switch (fields) {
    case "Mobile No.":
      if (mob_no_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    case "Email":
      if (email_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    case "Name":
      if (name_error.value === true) {
        return "input_error_fields";
      } else {
        return "input_fields";
      }
      break;
    default:
      return "input_fields";
      break;
  }
};

const openUploadDialog = () => {
  const fileInput = document.getElementById("fileInput");
  fileInput.click();
};

const generateThumbnailUrl = async (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

const fileUpload = debounce(async (e, question_no) => {
  const uploaded_file = e.target.files;
  if (uploaded_file[0].size > (calculatorData.isTata?1:5) * 1024 * 1024) {
    ElMessage({
      showClose: true,
      message:`File size should be less than ${calculatorData.isTata?'1':'5'}MB. Please try again`,
      type: "error",
      center: true,
    });
    return;
  }

  const uuidFile = v4();
  const fileData = {
    id: question_no.id,
    file_info: uploaded_file[0].name,
    file_name: uuidFile,
    url: undefined,
    file_type: uploaded_file[0].type,
  };

  const isValidFileType = ["application/pdf", "image/jpeg", "image/png", "image/gif"].includes(
    uploaded_file[0].type
  );
  
  if (isValidFileType) {
    try {
      const [_, thumbnailUrl] = await Promise.all([
        // upload to blob storage if its not Tata
        !calculatorData.isTata&&uploadFileToBlob(uploaded_file[0], uuidFile),
        generateThumbnailUrl(uploaded_file[0]),
      ]);

      // Get the base64 data without the data: prefix
      const base64Data = thumbnailUrl.split(",")[1];
      // No need to btoa since we already have the base64 data
      const url = base64Data;

      // Store in calculatorData
      const uploadFiles = { ...calculatorData.upload_files };
      uploadFiles[uuidFile] = {
        ...fileData,
        url: url
      };
      store.UPDATE_CALCULATOR_DATA(uploadFiles, 'File_Upload');

      uploadedFile.value = fileData;
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    const file_upload = {
      answer: {
        additional_info: {},
        corners: {
          address: "",
          center: {},
          coordinates: [],
          map_image: [],
          zoom: "",
        },
        deleted_files: [],
        files: [
          {
            file_info: uploaded_file[0].name,
            file_name: uuidFile,
            file_type: uploaded_file[0].type,
          },
        ],
        options: [],
        sub_options: {
          question_type: "",
          value: "",
        },
        text: "",
      },
      question: question_no.id,
      question_type: "file_upload",
      site_survey: calculatorData.site_survey_token,
    };
      const fd = new FormData();
// to upload documents directly to blob storage from Backend
    if(calculatorData.isTata){
      fd.append("answer",JSON.stringify (file_upload.answer));
      fd.append("question", file_upload.question);
      fd.append("question_type", file_upload.question_type);
      fd.append("site_survey", file_upload.site_survey);
      fd.append("file", uploaded_file[0]); // actual file
      fd.append("is_tata", true);
    }
    const callApi = debounce(async () => {
      await API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(calculatorData.isTata? fd: file_upload);
    });
    callApi();
  } else {
    ElMessage({
      showClose: true,
      message: "Please upload a valid file",
      type: "error",
      center: true,
    });
  }
}, 500);

const buttonStyles = () => {
  const validation = calculatorData.account_type == "Company/Society/Institution" && calculatorData.required_customer_field == "" 
  if(calculatorData.isTata && !props.isGenerate){
    return "moreDetailsButton";
  }
  if (
    Boolean(calculatorData.name) === true &&
    Boolean(calculatorData.email) === true &&
    Boolean(calculatorData.mobile_no) === true &&
    readAgreement.value === true &&
    !validation&&
    mob_no_error.value !== true &&
    email_error.value !== true &&
    name_error.value !== true
  ) {
    return "moreDetailsButton";
  } else {
    return "button_disabled";
  }
};


const buttonDisabled = () => {
  const validation = calculatorData.account_type == "Company/Society/Institution" && calculatorData.required_customer_field == "" 
  if(calculatorData.isTata && !props.isGenerate){
      return false;
    }
  if (
    Boolean(calculatorData.name) === false ||
    Boolean(calculatorData.email) === false ||
    Boolean(calculatorData.mobile_no) === false ||
    readAgreement.value !== true ||
    validation ||
    mob_no_error.value === true ||
    email_error.value === true ||
    name_error.value === true
  ) {
    return true;
  } else {
    return false;
  }
};

const handleFocus = (label) => {
  switch (label) {
    case "Mobile No.":
      mob_no_error.value = false;
      break;
    case "Email":
      email_error.value = false;
      break;
    case "Name":
      name_error.value = false;
      break;
    default:
      break;
  }
};

const uploadData = debounce((data, label, question_type, item) => {
  switch (question_type) {
    case "short_answer":
      const shortAnswer = {
        answer: {
          additional_info: {},
          corners: {
            address: "",
            center: "",
            coordinates: {},
            map_image: "",
            zoom: "",
          },
          deleted_files: [],
          files: [],
          options: [],
          sub_options: {
            question_type: "",
            value: "",
          },
          text: data.trim(),
        },
        question: item.id,
        question_type: "short_answer",
        site_survey: calculatorData.site_survey_token,
      };

      const callShortAnswer = async () => {
        API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(shortAnswer);
      };

      if (data.trim() !== "") {
        callShortAnswer();
      }

      break;
    case "number":
      const number = {
        answer: {
          additional_info: {},
          corners: {
            address: "",
            center: {},
            coordinates: [],
            map_image: [],
            zoom: "",
          },
          deleted_files: [],
          files: [],
          options: [],
          sub_options: {
            question_type: "",
            value: "",
          },
          text: label == "Mobile No." ? data.slice(0, 10) : data,
        },
        question: item.id,
        question_type: "number",
        site_survey: calculatorData.site_survey_token,
      };

      const callNumber = async () => {
        API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(number);
      };
      callNumber();
      break;

    case "dropdown":
      const dropdown = {
        answer: {
          additional_info: {},
          corners: {
            address: "",
            center: "",
            coordinates: {},
            map_image: "",
            zoom: "",
          },
          deleted_files: [],
          files: [],
          options: data,
          sub_options: {
            question_type: "",
            value: "",
          },
          text: "",
        },
        question: item.id,
        question_type: "dropdown",
        site_survey: calculatorData.site_survey_token,
      };
      const callApi = async () => {
        API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(dropdown);
      };
      callApi();
      break;
    case "multiple_choice":
      const single_choice = {
        answer: {
          additional_info: {},
          corners: {
            address: "",
            center: {},
            coordinates: [],
            map_image: [],
            zoom: "",
          },
          deleted_files: [],
          files: [],
          options: data,
          sub_options: {
            question_type: "",
            value: "",
          },
          text: "",
        },
        question: item.id,
        question_type: "multiple_choice",
        site_survey: calculatorData.site_survey_token,
      };

      const callChoices = async () => {
        API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(single_choice);
      };
      callChoices();
      break;
    default:
      return null;
      break;
  }
}, 1000);


const preventSpecialCharacters = (label, e) => {
  if (label === "Mobile No.") {
    if (
      e.key === "e" ||
      e.key === "E" ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "."
    ) {
      e.preventDefault();
    }
  }
};

const updateCalculatorData = (data, label, question_type, item) => {
  if (label === "Mobile No.") {
    if (item.additional_info.default_option > 9999999999) {
      item.additional_info.default_option =
        item.additional_info.default_option.slice(0, 10);
    }
    store.UPDATE_CALCULATOR_DATA(item.additional_info.default_option, label);
  }

  if (label === "Name") {
    if (validateName(item.additional_info.default_option))
      store.UPDATE_CALCULATOR_DATA(
        item.additional_info.default_option.trim(),
        label
      );
  }
  if(label == "Account Type"){
    store.UPDATE_CALCULATOR_DATA(
      data,
      "Account Type"
    );
  }
  if(label == "Company/Society/Institution Name"){
    store.UPDATE_CALCULATOR_DATA(
      data,
      "required_customer_field"
    );
  }
  store.UPDATE_CALCULATOR_DATA(data, label);
  uploadData(data, label, question_type, item);
};

const handleValidation = (data, label) => {
  switch (label) {
    case "Name":
      if (data === "" || data === null || data === undefined) {
        name_error.value = false;
      } else {
        name_error.value = validateName(data);
      }
      break;
    case "Mobile No.":
      if (data === "" || data === null || data === undefined) {
        mob_no_error.value = false;
      } else {
        const mobile_no = parseInt(data);
        if (validateMobileNumber(mobile_no)) {
          store.UPDATE_CALCULATOR_DATA(data, label);
          mob_no_error.value = false;
        } else {
          mob_no_error.value = true;
        }
      }
      break;
    case "Email":
      if (data === "" || data === null || data === undefined) {
        email_error.value = false;
      } else {
        email_error.value = !isValidEmail(data.trim());
      }
      break;
    default:
      break;
  }
};

function isValidEmail(text) {
  if (text.includes('-')) {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(text);
}

const updateAnswerApi = (item) => {
  const single_choice = {
    answer: {
      additional_info: {},
      corners: {
        address: "",
        center: {},
        coordinates: [],
        map_image: [],
        zoom: "",
      },
      deleted_files: [],
      files: [],
      options: item.additional_info.default_option,
      sub_options: {
        question_type: item.options[0].sub_options[0].question_type,
        value: item.options[0].sub_options[0].additional_info.default_option,
      },
      text: "",
    },
    question: item.id,
    question_type: item.question_type,
    site_survey: calculatorData.site_survey_token,
  };

  const callChoices = async () => {
    API.EDITABLE_SITE_SURVEY_API.PATCH_ANSWERS(single_choice);
  };
  callChoices();
};

function validateMobileNumber(mobileNumber) {
  const mobileNumberPattern = /^\d{10}$/;
  return mobileNumberPattern.test(mobileNumber);
}

function validateName(input) {
  const hasAlphabetic = /[a-zA-Z]/.test(input);
  // should not contain html tags
  const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(input);

  const isNotJustSpaces = input.trim() !== "";

  if (!hasAlphabetic || !isNotJustSpaces || hasHtmlTags) {
    return true;
  }
  return false;
}

const setTimerValue = () => {
  timer.value = 60;
  const interval = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    } else {
      clearInterval(interval);
    }
  }, 1000);
};

const verifyDetails = async () => {
  if(calculatorData.isTata && !props.isGenerate) {
    store.UPDATE_CALCULATOR_DATA(false, "showRoiButton");
    emit('generateResults');
    emit('update:dialogVisible', false);
    return;
  }
  loading.value = true;
  const send_otp_data = {
    phone: `91${calculatorData.mobile_no}`,
    org:263,
    domain: calculatorData.orgName,
  };

  try {
    await API.SOLARCALCULATOR.SEND_OTP(send_otp_data);
    setTimerValue();
    ElMessage({
      showClose: true,
      message: "OTP sent",
      type: "success",
      center: true,
    });
    optArray.value = [];
    loading.value = false;
    // dialogVisible.value = !dialogVisible.value;
    emit('update:dialogVisible', false)
    emit('verificationDialog', true);
  } catch (err) {
    ElMessage({
      showClose: true,

      // message:
      //   err.response.data === "Invalid Number"
      //     ? "Input valid mobile number"
      //     : "Unable to send OTP",
      type: "error",
      center: true,
    });
  }

    loading.value = false;
};


const handleLeadCaptureClose = () => {
  emit('update:dialogVisible', false)
};

const dialogVisible = ref(props.dialogVisible);

const handleClose = (done) => {
  emit('update:dialogVisible', false)
}
</script>


<style scoped>
.main_outage_form {
display: flex;
gap: 10px;
}

.wrapper_outage_form {
margin-top: 10px;
display: flex;
align-items: center;
padding: 5px;
box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
border-radius: 8px;
flex: 1;
height: 10vh;
}

.powerCard {
flex: 1;
display: flex;
height: 64px;
padding: 10px 16px;
align-items: center;
justify-content: center;
gap: 10px;
border-radius: 8px;
background: var(--White, #fff);
box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
}

.blueButton {
padding-top: 10px;
padding-bottom: 10px;
background-color: #006eaf;
border: none;
outline: none;
color: var(--grey-grey-100, var(--White, #fff));
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 700;
cursor: pointer;
}

.right {
display: flex;
flex-direction: column;
gap: 10px;
margin-left: 10px;
}

.blueContainer {
display: flex;
align-items: center;
justify-content: center;
background-color: #006eaf;
margin-top: 10px;
border-radius: 8px;
}

.dialogCustom {
position: relative;
height: 100%;
}

.dialogVerification >>> .el-dialog__header {
background-color: #e8edf2;
margin-right: 0;
border-radius: 8px 8px 0px 0px;
}

.dialogCustom >>> .el-dialog__header {
background-color: #e8edf2;
margin-right: 0;
border-radius: 10px 10px 0px 0px;
padding: 0;
padding-left: 20px;
padding-right: 20px;
padding-top: 15px;
padding-bottom: 15px;
width: 100%;
position: sticky;
top: 0;
z-index: 999;
}

.dialogVerification >>> .el-dialog__header {
background-color: #e8edf2;
margin-right: 0;
border-radius: 10px 10px 0px 0px;
padding: 0;
padding-left: 20px;
padding-right: 20px;
padding-top: 15px;
padding-bottom: 15px;

position: sticky;
}

.slider_inner_button {
background-color: black;
color: white;
border: none;
margin-bottom: 1px;
cursor: pointer;
}

.slider_inner_disable_button {
background-color: #ccc;
color: white;
border: none;
margin-bottom: 2px;
cursor: not-allowed;
}

.dialogCustom >>> .el-checkbox__inner {
z-index: 0;
}

.dialogCustom >>> .el-checkbox__inner {
z-index: 0;
}

.dialogCustom >>> .el-checkbox__input {
background-color: yellow;
}

.dialogVerification >>> .el-dialog__body {
padding: 16px;
color: black;
}

.dialogCustom >>> .el-dialog__body {
padding: 0px;
color: black;
}

.moreDetailsButton {
width: 100%;
border: none;
outline: none;
background-color: var(--Primary-Tata, #006eaf);
border-radius: 8px;
cursor: pointer;
font-weight: 700;
font-size: 16px;
color: white;
padding: 16px;
z-index: 999;
}

.diffOrgButton {
  background-color: #409EFF;
}

.button_disabled {
padding: 16px;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
border-radius: 8px;
cursor: not-allowed;
width: 100%;
border: none;
height: 100%;
background-color: #C6E2FF;
outline: none;
color: #fff;
}

.loading_popup >>> .el-dialog__headerbtn {
display: none;
}

.loading_popup >>> .el-dialog__header {
display: none;
}

.loading_popup :deep() .el-dialog {
padding: 0px;
border-radius: 8px;
}

.productTypes {
margin-top: 10px;
}

.cards {
margin-top: 10px;
height: 20vh;
/* background-color: #006eaf; */
display: flex;
align-items: center;
justify-content: center;
border-radius: 8px;
}

.cardWrapper {
color: black;
display: flex;
flex-direction: column;
gap: 10px;
align-items: center;
justify-content: center;
}

.input_containers {
margin-top: 10px;
}

.input_containers :deep() .el-input__inner {
color: black;
font-size: 16px;
background: #fff;
}
.logo_card {
margin-top: 10px;
border-radius: 8px;
padding: 10px;
border: 1px solid #cccccc;
}
.input_fields {
margin-top: 5px;
color: black;
}

.input_error_fields {
margin-top: 5px;
color: black;
}

.input_fields >>> .el-input.is-disabled .el-input__inner {
color: #2c2727; /* Change this color to your desired text color */
}

.input_error_fields >>> .el-input.is-disabled .el-input__inner {
color: #2c2727; /* Change this color to your desired text color */
}

.input_capacity {
display: flex;
height: 48px;
padding: 10px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
border: none;
background: var(--White, #fff);
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
margin-top: 5px;
}

.input_capacity >>> .el-input-group__append {
box-shadow: none;
background-color: white;
}
.input_fields >>> .el-input__wrapper,
.input_error_fields >>> .el-input__wrapper {
display: flex;
height: 48px;
padding: 10px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
background: var(--White, #fff);
box-shadow: none;
}

.is_focus {
outline: none;
border: none;
}

.mainPowerContainer {
margin-top: 10px;
border: 1px solid var(--CCC, #ccc);
padding: 10px;
border-radius: 5px;
}

.pinInputContainer {
display: flex;
gap: 20px;
}

.pinInput {
width: 50px;
text-align: center;
border-radius: 2px;
border: none;
border-bottom: 1px solid grey;
outline: none;
font-size: 18px;
padding: 5px;
}

.PDcard {
padding: 16px 10px;
border-radius: 4px;
background-color: #e8edf2;
text-align: center;
height: 200px;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
width: 120px;
height: 120px;
border: 1px dashed var(--999, #999);
gap: 8px;
cursor: pointer;
align-self: center;
}

.productTypes >>> .el-radio__input.is-checked + .el-radio__label {
color: black;
}

.productTypes >>> .el-radio__input.is-checked .el-radio__inner {
border-color: #006eaf;
background-color: white;
border: 2px solid #006eaf;
}

.number_input >>> .el-input-number__decrease {
border-radius: 50%;
background-color: #0d0d0d;
color: white;
font-size: 14px;
width: 30px;
height: 30px;
}

.Verification {
position: sticky;
bottom: 0;
background: var(--White, #fff);
box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.25);
width: 100%;
padding: 10px;
}

.fixed-header {
position: sticky;
top: 0;
}

.veri_button {
background: var(--White, #fff);
width: 100%;
padding-top: 30px;
padding-left: 30px;
padding-right: 30px;
padding-bottom: 15px;
display: flex;
align-items: center;
}

.number_input >>> .el-input-number__increase {
border-radius: 50%;
background-color: #0d0d0d;
color: white;
height: 30px;
width: 30px;
font-size: 14px;
}

.time_input {
border-radius: 4px;
border: 1px solid var(--999, #999);
background: var(--White, #fff);
width: 60px;
padding: 5px;
display: flex;
align-items: center;
cursor: not-allowed;
}

.appliances_input {
border-radius: 8px;
border: 1px solid var(--CCC, #ccc);
background: var(--White, #fff);
width: 70px;
padding: 5px;
display: flex;
align-items: center;
height: 35px;
}

.time_button {
cursor: pointer;
}

.appliances_time_button {
height: 22px;
width: 22px;
border: none;
border-radius: 50%;
color: white;
background-color: #006eaf;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}

.time_disabled_button {
/* height: 22px;
width: 22px;
border-radius: 50%;
border: none;
color: white;
background-color: #ccc;
display: flex;
align-items: center;
justify-content: center; */
cursor: not-allowed;
}

.appliances_time_disabled_button {
cursor: not-allowed;
}

.time_input >>> input[type="number"]::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}
.watt_appliances >>> input[type="number"]::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}
.input_error_fields >>> input[type="number"]::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}
.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

.number_input >>> .el-input__inner {
border: 1px;
box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
  inset;
}

.number_input >>> .el-input__wrapper {
box-shadow: none;
}

.productTypes >>> .el-radio__inner::after {
height: 6px;
width: 5.5px;
background-color: #006eaf;
top: 50%;
left: 50%;
}

.requiredClass {
color: red;
}

.dropdownContainer {
width: 100%;
}

.dropdownContainer >>> .el-select .el-input__wrapper {
display: flex;
height: 48px;
width: 100%;
padding: 10px 12px;
justify-content: space-between;
align-items: center;
align-self: stretch;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
background: var(--White, #fff);
}

.appliances_number_input :deep() .el-input-number__decrease {
border-radius: 50%;
background-color: #006eaf;
color: #fff;
height: 50%;
top: 25%;
width: 13%;
}

.appliances_number_input :deep() .el-input-number__increase {
border-radius: 50%;
background-color: #006eaf;
color: #fff;
height: 50%;
top: 25%;
width: 13%;
right: 19%;
}

.appliances_number_input :deep() .el-input__wrapper {
box-shadow: none;
}

.appliances_number_input :deep() .el-input__inner {
height: 35px;
box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
  inset;
border-radius: 8px;
position: relative;
left: -22%;
}

.watt_appliances :deep() .el-input__wrapper {
width: 90px;
border-radius: 8px;
border: 1px solid var(--CCC, #ccc);
background: var(--White, #fff);
box-shadow: none;
}

.productTypes >>> .el-select .el-input__wrapper {
display: flex;
height: 48px;
padding: 10px 12px;
justify-content: space-between;
align-items: center;
align-self: stretch;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
background: var(--White, #fff);
margin-top: 10px;
box-shadow: none;
}

.productTypes >>> .el-select__wrapper {
  height: 48px;
  border: 1px solid #ccc;
  box-shadow: none;
  border-radius: 8px;
}

.error_field {
margin-top: 5px;
color: red;
font-size: 12px;
}

.dialogCustom >>> .el-dialog {
overflow: scroll;
border-radius: 10px;
position: relative;
padding: 0;
}

.loading_popup >>> .el-dialog {
  height: auto;
}

.dialogVerification >>> .el-dialog {
border-radius: 10px;
}

.input_time {
outline: none;
border: none;
width: 20px;
cursor: not-allowed;
}

.appliances_input_value {
outline: none;
border: none;
width: 100%;
}

.appliances_watt_value {
width: 80px;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
background: var(--White, #fff);
height: 35px;
padding: 5px;
outline: none;
}
.time_container {
margin-top: 10px;
padding: 10px;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ccc);
background: var(--White, #fff);
}

.input_number {
display: flex;
align-items: center;
gap: 10px;
}

.check_box {
margin-top: 10px;
padding-left: 20px;
padding-right: 20px;
margin-bottom: 10px;
}

.check_box >>> .el-checkbox__input.is-checked + .el-checkbox__label {
color: black;
}

.dialog_title {
color: var(--222, #222);
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.error_dialog_title {
color: red;
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.unit_text {
color: var(--Grey-777, var(--777, #777));
font-family: Poppins;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.img_container {
position: relative;
box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
  inset;
margin-top: 10px;
border-radius: 8px;
display: flex;
width: 120px;
height: 120px;
padding: 12px;
flex-direction: column;
gap: 10px;
justify-content: center;
align-items: center;
background: var(--Background, #e8edf2);
}

.el-message.is-closable .el-message__content {
z-index: 9999;
}

.delete-button {
display: none;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}

.verifyHeader {
color: #000;
text-align: center;
font-family: Arial;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.info_note {
color: var(--Grey-777, var(--777, #777));
font-family: Arial;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-top: 10px;
}

.dialogCustom >>> .el-dialog {
scrollbar-width: none; /* Firefox */
-ms-overflow-style: none; /* Internet Explorer */
border-radius: 8px;
}

.upload-demo >>> .el-upload-dragger {
display: flex;
width: 120px;
height: 120px;
padding: 12px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 8px;
border: 1px dashed var(--Grey-777, #777);
background: var(--White, #fff);
}

.capacity_input {
border: none;
outline: none;
background-color: white;
color: black;
font-size: 16px;
width:80%;
}

.capacity_input:hover {
cursor: no-drop;
}

.input_capacity:hover {
cursor: no-drop;
}

.otp_not_received {
color: var(--777, #777);
text-align: center;
font-family: Arial;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.verify_received {
color: var(--White, #fff);
font-family: Arial;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: normal;
}

.file_input {
height: 100%;
width: 100%;
display: none;
}

.otp_send {
color: #000;
text-align: center;
font-family: Arial;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-decoration-line: underline;
cursor: pointer;
}

.otp_send_disabled {
color: #ccc;
text-align: center;
font-family: Arial;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-decoration-line: underline;
cursor: not-allowed;
}

.input_field_error >>> .el-input__wrapper {
display: flex;
height: 48px;
padding: 10px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
border-radius: 8px;
border: 1px solid var(--Grey-CCC, #ef1212);
background: var(--White, #fff);
}

.file_upload_card {
display: flex;
width: 120px;
height: 120px;
padding: 12px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 8px;
border: 1px dashed var(--Grey-777, #777);
background: var(--White, #fff);
margin-top: 10px;
cursor: pointer;
}

.custom-checkbox.customCheckboxColor >>> .el-checkbox__input.is-checked .el-checkbox__inner {
background-color: #006eaf;
border: #006eaf;
}

.custom-checkbox.customCheckboxColor :deep() .el-checkbox__inner::after {
left: 5px;
top: 2px;
}

.details_card {
padding: 10px;
margin-top: 10px;
background-color: var(--777, #edf1f5);
border-radius: 8px;
box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
  inset;
}

.contact_details {
font-weight: bold;
font-size: 14px;
line-height: 18px;
color: #006eaf;
}

.contact_info {
font-size: 14px;
line-height: 18px;
font-weight: bold;
}

.contact_wrapper {
display: flex;
align-items: center;
padding: 10px;
gap: 10px;
}

.note {
color: var(--Grey-777, var(--777, #777));
font-family: Arial;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.dialogCustom >>> .el-dialog__headerbtn {
display: none;
}

.dialogVerification >>> .el-dialog__headerbtn {
display: none;
}

.dialogCustom >>> .el-dialog::-webkit-scrollbar {
display: none; /* Webkit (Chrome, Safari, etc.) */
}
.input_fields >>> .el-input-number__decrease {
display: none;
}

.input_error_fields >>> .el-input-number__decrease {
display: none;
}

.appliances_details_container {
display: flex;
align-items: center;
justify-content: end;
gap: 13px;
}

.main_appliances_container {
border-radius: 8px;
border: 1px solid #ccc;
background: #fff;
padding: 16px;
display: flex;
gap: 10px;
flex-direction: column;
margin-top: 15px;
}

.appliances_title {
margin-top: 12px;
margin-bottom: 12px;
color: var(--777, #777);
font-family: Arial;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: normal;
}

.appliances_add_button {
display: flex;
align-items: center;
justify-content: end;
}

.appliances_button {
border: none;
background-color: white;
color: #184d93;
font-family: Poppins;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 26px; /* 162.5% */
cursor: pointer;
}

.appliances_details {
color: var(--777, #777);
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.hrClass {
border-top: 2px solid #cccccc;
}

.appliances_values {
color: #000;
font-family: Poppins;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: normal;
}

.appliances_names {
color: var(--Black, var(--222, #222));
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.appliances_table {
display: flex;
padding: 0px 16px;
flex-direction: column;
align-items: center;
align-self: stretch;
border-radius: 8px;
border: 1px solid var(--CCC, #ccc);
}

.appliances_input >>> input[type="number"]::-webkit-inner-spin-button,
.appliances_input input[type="number"]::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
color: red;
}

.input_time >>> input[type="number"]::-webkit-inner-spin-button,
.input_time input[type="number"]::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
color: red;
}

.my-header {
color: #000;
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
}

.edit_data {
margin-left: 90%;
display: flex;
align-items: center;
gap: 10px;
}

.edit_data_actions {
margin-left: 57%;
display: flex;
align-items: center;
gap: 10px;
}

@media (max-width: 827px){
.dialogCustom >>> .el-dialog {
  width: 90%;
  -ms-overflow-style: none;
}
}

@media (max-width: 1180px)  {
.dialogCustom >>> .el-dialog {
  width: 90%;
  -ms-overflow-style: none;
}

.loading_popup :deep() .el-dialog {
  padding: 0px;
  border-radius: 8px;
  width: 90%;
}
.dialogVerification >>> .el-dialog {
  width: 90%;
}

.main_appliances_container {
  padding: 8px;
}

.hours_card {
  flex-direction: column;
}

.time_container {
  width: 100%;
}

.right {
  margin-left: 20px;
}
}

@media (max-width: 740px) {

.dialogCustom >>> .el-dialog {
  max-height: 90vh;
}
.time_container {
  width: 100%;
}
.hours_card {
  flex-direction: column;
}
}
.collaps-content{
display:flex;
flex-direction: row;
padding-top:16px;
width: 100%;

}

.collaps-content-label{
flex:0.5;
}
.collaps-content-value{
flex:0.5;
display: flex;
justify-content: flex-end;
}
.collaps-content-name{
flex:0.5;
display: flex;
}
.collapse_container>>>.el-collapse-item__content{
padding-bottom:0px

}
.btn_container{
display: flex;
justify-content: flex-end;
}
</style>